var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { setT } from 'helpers/translationUtilities';
RecipientSelection.propTypes = {
    changeStep: PropTypes.func,
    receivers: PropTypes.array
};
export default function RecipientSelection(_a) {
    var _b = _a.changeStep, changeStep = _b === void 0 ? null : _b, _c = _a.receivers, receivers = _c === void 0 ? [] : _c;
    var companies = useSelector(function (state) { return state.general.companies; });
    var players = useSelector(function (state) { return state.general.players; });
    var companiesAndPlayers = useMemo(function () { return __spreadArray(__spreadArray([], companies, true), players, true); }, [companies, players]);
    return (React.createElement(Fragment, null,
        React.createElement("div", null,
            receivers.length
                ? hasBeenSelectedMessage(receivers, companiesAndPlayers)
                : null,
            changeStep ? (React.createElement("button", { className: "main-button main-button--lg", onClick: function () { return changeStep(); } }, receivers.length ? setT('change') : setT('select'))) : null)));
}
function hasBeenSelectedMessage(receivers, companiesAndPlayers) {
    var messageString = '';
    if (receivers.length > 1) {
        messageString = 'Multiple subjects selected';
    }
    else {
        var foundPlayer = companiesAndPlayers.find(function (entity) { return receivers[0] === entity.id; });
        if (foundPlayer) {
            messageString = "".concat(foundPlayer.name, " selected");
        }
    }
    return React.createElement("div", { className: "payment__message" }, messageString);
}
